var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-i"},[_c('div',{staticClass:"content-box"},[_c('top-section'),_c('listing')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }